var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLastBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7674 13.2846L14.1269 17.7141L23.0332 22.2617L31.9396 17.7141L23.2991 13.2846C23.0332 13.1664 22.9003 13.1664 22.7674 13.2846ZM32.6042 18.7181L23.6979 23.2658V32.4792L32.4048 28.0497C32.5378 27.9906 32.6042 27.8725 32.6042 27.6953V18.7181ZM13.3958 18.7181V27.6362C13.3958 27.7544 13.4622 27.9315 13.5952 27.9906L22.3021 32.4201V23.3248L13.3958 18.7181ZM23.8973 12.2215L33.0695 16.8872C33.6677 17.1826 34 17.7141 34 18.3047V27.6953C34 28.2859 33.6677 28.8174 33.0695 29.1128L23.8973 33.7785C23.2991 34.0738 22.6344 34.0738 22.0363 33.7785L12.9305 29.1128C12.3323 28.8174 12 28.2859 12 27.6953V18.3047C12 17.7141 12.3323 17.1826 12.9305 16.8872L22.1027 12.2215C22.6344 11.9262 23.2991 11.9262 23.8973 12.2215Z",
    fill: "#181719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastBlock);
export default __webpack_public_path__ + "static/media/last-block.bf6f910605d4061061ae342c53dc1afb.svg";
export { ForwardRef as ReactComponent };